module.exports = __webpack_public_path__ + "static/bns-386509cf8bb90f2e923ae3289d60354c.png";